// import { validation } from '/source/_patterns/01-components/form/form';
import { IS_HIDDEN } from '/source/js/base/baseClasses';
import friendList from './partials/friend-list.hbs';
import findReferralNoResults from '../checkout/partials/find-referral-no-results.hbs';
import * as enrollmentService from '/source/js/services/enrollmentService';
import * as checkoutService from '/source/js/services/checkoutService';
import { validateForm } from '/source/_patterns/01-components/form/form';
import { showSpinner, hideSpinner } from '/source/_patterns/01-components/spinner/spinner';
import { moveToNextCheckoutStep, isRequiredField } from '/source/_patterns/01-components/checkout/checkout-shared';
import { startFindAFriend, completeFindAFriend, setGenericData } from '/source/js/gtm/IsaGtmCommerce';

const REFERRAL_TYPE_REFERRED = 'referred';
const SEARCH_TYPE_BY_NAME = 'nameSearch';
const SEARCH_TYPE_BY_PHONE = 'phoneSearch';
const SEARCH_TYPE_BY_MEMBERID = 'memberIdSearch';
const IS_ERROR = 'is--error';

export function enrollNext() {
    let $this = $(this);
    let $checkoutStep = $('.checkout__form-step');
    $checkoutStep.addClass(IS_HIDDEN);
    $this.parents($checkoutStep).next().removeClass(IS_HIDDEN);
    $('html,body').animate({
        scrollTop: 0
    });
}

export function enrollPrev() {
    let $this = $(this);
    let $checkoutStep = $('.checkout__form-step');
    $checkoutStep.addClass(IS_HIDDEN);
    $this.parents($checkoutStep).prev().removeClass(IS_HIDDEN);
}

function toggleSearch() {
    changeNextButtonState({ disabled: true });
    let $friendList = $('.self-enrollment__friend-list');
    $friendList.children('h2').text('');
    $friendList.children('ul').remove();
    let value = $(this).val();
    let $friendSearch = $('.self-enrollment__friend-search');
    $friendSearch.addClass(IS_HIDDEN);
    if(value === 'nameSearch') {
        $(`#${value}`).removeClass(IS_HIDDEN);
    } else if(value === 'phoneSearch') {
        $(`#${value}`).removeClass(IS_HIDDEN);
    } else if(value === 'memberIdSearch') {
        $(`#${value}`).removeClass(IS_HIDDEN);
    }
}

function toggleFriend($option) {
    if($option.val() === REFERRAL_TYPE_REFERRED) {
        $('.self-enrollment__friend').removeClass('is--hidden');
    } else {
        $('.self-enrollment__friend').addClass('is--hidden');
    }
}

function buildSearchRequest() {
    let searchType = getSearchType();
    if($('#integrated-referral-form').length) {
        let selectedValue = $('input[name="searchBy"]:checked').val();
        if(selectedValue === 'name') {
            searchType = SEARCH_TYPE_BY_NAME;
        } else if(selectedValue === 'phone') {
            searchType = SEARCH_TYPE_BY_PHONE;
        } else if(selectedValue === 'memberId') {
            searchType = SEARCH_TYPE_BY_MEMBERID;
        }
    }
    if(searchType === SEARCH_TYPE_BY_NAME) {
        return {
            searchBy: $('#searchBy').val(),
            firstName: $('#firstNameFriend').val(),
            lastName: $('#lastNameFriend').val(),
            country: $('#countryFriend').val(),
            state: $('#stateFriend').val()
        };
    } else if(searchType === SEARCH_TYPE_BY_PHONE) {
        return {
            searchBy: $('#searchBy').val(),
            phone: $('#phoneFriend').val(),
            phoneCountry: $('#phoneCountryFriend').val()
        };
    } else if(searchType === SEARCH_TYPE_BY_MEMBERID) {
        return {
            searchBy: $('#searchBy').val(),
            memberId: $('#memberIdFriend').val()
        };
    }
    return undefined;
}

function createValidationMessageContainerElement(id) {
    const cleanId = id.startsWith('#') ? id.slice(1) : id;
    if(cleanId) {
        return createMessageContainerElement(cleanId, 'data-msg-validation');
    }
}

function createErrorMessageContainerElement(id) {
    const cleanId = id.startsWith('#') ? id.slice(1) : id;
    if(cleanId) {
        return createMessageContainerElement(cleanId, 'data-msg-required');
    }
}

function createMessageContainerElement(id, dataAttr) {
    const $el = $(`#${id}`);
    if($(`#${id}-error`).length) {
        return;
    }

    return $('<span>', {
        id: `${id}-error`,
        class: 'error account-referral-form-required-message-element',
        text: $el.attr(dataAttr) || 'Required'
    });
}

function validateSearchByNameForm() {
    let isValid = true;

    const firstName = $.trim($('#firstNameFriend').val());
    const lastName = $.trim($('#lastNameFriend').val());
    const country = $('#countryFriend').val();
    const state = $('#stateFriend').val();
    $('#nameSearch .form-block').removeClass('is--error');
    $('#nameSearch .mod-field').removeClass('mod-field--error');
    $('#nameSearch .mod-dropdown__select-wrap').removeClass('is--error');
    if(firstName === '') {
        const id = '#firstNameFriend';
        $(id).closest('.form-block').addClass('is--error');
        $(id).closest('.mod-field').addClass('mod-field--error');
        isValid = false;
        $(id).after(createErrorMessageContainerElement(id));
    }

    if(lastName === '') {
        const id = '#lastNameFriend';
        $(id).closest('.form-block').addClass('is--error');
        $(id).closest('.mod-field').addClass('mod-field--error');
        isValid = false;
        $(id).after(createErrorMessageContainerElement(id));
    }

    if(!country || country === 'default') {
        const id = '#countryFriend';
        $(id).closest('.form-block').addClass('is--error');
        $(id).closest('.mod-dropdown__select-wrap').addClass('is--error').after(createErrorMessageContainerElement(id));
        isValid = false;
    }

    if(!state || state === 'default') {
        const id = '#stateFriend';
        $(id).closest('.form-block').addClass('is--error');
        $(id).closest('.mod-dropdown__select-wrap').addClass('is--error').after(createErrorMessageContainerElement(id));
        isValid = false;
    }

    return isValid;
}

function validateSearchByPhoneNumberForm() {
    let isValid = true;

    const country = $('#phoneCountryFriend').val();
    const phone = $.trim($('#phoneFriend').val());
    $('#phoneSearch .form-block').removeClass('is--error');
    $('#phoneSearch .mod-field').removeClass('mod-field--error');
    $('#phoneSearch .mod-dropdown__select-wrap').removeClass('is--error');
    if(!country || country === 'default') {
        $('#phoneCountryFriend').closest('.form-block').addClass('is--error');
        $('#phoneCountryFriend').closest('.mod-dropdown__select-wrap').addClass('is--error').after(createErrorMessageContainerElement('#phoneCountryFriend'));
        isValid = false;
    }

    if(phone === '') {
        const id = '#phoneFriend';
        $(id).closest('.form-block').addClass('is--error');
        $(id).closest('.mod-field').addClass('mod-field--error');
        isValid = false;
        $(id).after(createErrorMessageContainerElement(id));
    }

    return isValid;
}

function validateSearchByMemberIdForm() {
    let isValid = true;
    const memberId = $.trim($('#memberIdFriend').val());
    $('#memberIdSearch .form-block').removeClass('is--error');
    $('#memberIdSearch .mod-field').removeClass('mod-field--error');
    const id = '#memberIdFriend';
    if(memberId === '') {
        $(id).closest('.form-block').addClass('is--error');
        $(id).closest('.mod-field').addClass('mod-field--error');
        isValid = false;
        $(id).after(createErrorMessageContainerElement(id));
    } else {
        if(!/^\d+$/.test(memberId)) {
            $(id).closest('.form-block').addClass('is--error');
            $(id).closest('.mod-field').addClass('mod-field--error');
            isValid = false;
            $(id).after(createValidationMessageContainerElement(id));
        }
    }

    return isValid;
}

async function findAFriend() {
    let formIsValidated = false;
    if($('#integrated-referral-form').length) {
        let selectedValue = $('input[name="searchBy"]:checked').val();
        if(selectedValue === 'name') {
            formIsValidated = validateSearchByNameForm();
        } else if(selectedValue === 'phone') {
            formIsValidated = validateSearchByPhoneNumberForm();
        } else if(selectedValue === 'memberId') {
            formIsValidated = validateSearchByMemberIdForm();
        }
    }
    const findAFriendPageReferralFormIsValid = isValidSearchForm() && $('#integrated-referral-form').length === 0;
    const accountPageReferralFormIsValid = formIsValidated && $('#integrated-referral-form').length !== 0;
    if(findAFriendPageReferralFormIsValid || accountPageReferralFormIsValid) {
        let request = buildSearchRequest();
        changeNextButtonState({ disabled: true });
        showSpinner('find a friend search started');
        let result = await enrollmentService.findAFriend(request);
        hideSpinner('find a friend search completed');
        let $friendsList = $('.self-enrollment__friend-list');
        const isModernized = $friendsList.hasClass('modernized');
        let noResultsHtml = `<h2 class="h5 is--dm-serif pl-2">${$friendsList.data('notfound')}</h2>`;
        if(result && result.IsSuccessful) {
            if(result.Members && result.Members.length > 0) {
                if(isModernized) {
                    $friendsList.find('.referral-no-results-found').remove();
                    $friendsList.find('.self-enrollment__friends-count, ul').remove();
                    $friendsList.removeClass('has-no-results').addClass('has-results');
                    $friendsList.append($(friendList(result.Members)));
                } else {
                    $friendsList.html(friendList(result.Members));
                }
            } else {
                if(isModernized) {
                    $friendsList.find('.referral-no-results-found').remove();
                    $friendsList.find('.self-enrollment__friends-count, ul').remove();
                    $friendsList.removeClass('has-results').addClass('has-no-results');
                    const noResultsHeader = $friendsList.data('no-results-header');
                    const noResultsBody = $friendsList.data('no-results-body');
                    $friendsList.prepend(findReferralNoResults({ noResultsHeader, noResultsLead: noResultsBody }));
                } else {
                    $friendsList.html(noResultsHtml);
                }
            }
        } else {
            if(isModernized) {
                $friendsList.find('.referral-no-results-found').remove();
                $friendsList.find('.self-enrollment__friends-count, ul').remove();
                $friendsList.removeClass('has-results').addClass('has-no-results');
                const noResultsHeader = $friendsList.data('no-results-header');
                const noResultsBody = $friendsList.data('no-results-body');
                $friendsList.prepend(findReferralNoResults({ noResultsHeader, noResultsLead: noResultsBody }));
            } else {
                $friendsList.html(noResultsHtml);
            }
        }
    }
}

function handleFriendTypeChange() {
    let $option = $(this);
    toggleFriend($option);
    evaluateNextButton($(this).val());
}

function evaluateNextButton(friendType) {
    if(friendType === REFERRAL_TYPE_REFERRED) {
        var $referredPerson = $('input[name="referredPerson"]');
        if($referredPerson.length > 0 && $referredPerson.is(':checked')) {
            changeNextButtonState();
        } else {
            changeNextButtonState({ disabled: true });
        }
    } else {
        changeNextButtonState();
        $('.self-enrollment__friend-list').empty();
    }
}

function changeNextButtonState(option) {
    const $findFriendSection = $('#findFriendSection');
    if(!$findFriendSection.hasClass('d-none')) {
        $findFriendSection.find('.search-error-alert-faf').addClass('d-none');
    }
    let $btn = $('.findFriendNext');
    if(option && option.disabled) {
        $btn.attr('disabled', true);
    } else {
        $btn.removeAttr('disabled');
    }
}

function getSearchByNameValidationConfiguration() {
    return {
        onfocusout: function (element) {
            this.element(element);
        },
        highlight: function (element) {
            $(element).parent().addClass(IS_ERROR);
        },
        unhighlight: function (element) {
            $(element).parent().removeClass(IS_ERROR);
        },
        ignore: null,
        errorElement: 'span',
        rules: {
            firstNameFriend: {
                required: true
            },
            lastNameFriend: {
                required: true
            },
            countryFriend: {
                required: true,
                hasValidSelection: true
            },
            stateFriend: {
                required: true,
                hasValidSelection: true
            }
        }
    };
}

function getSearchByPhoneValidationConfiguration() {
    return {
        onfocusout: function (element) {
            this.element(element);
        },
        highlight: function (element) {
            $(element).parent().addClass(IS_ERROR);
        },
        unhighlight: function (element) {
            $(element).parent().removeClass(IS_ERROR);
        },
        ignore: null,
        errorElement: 'span',
        rules: {
            phoneFriend: {
                required: true
            },
            phoneCountryFriend: {
                required: true,
                hasValidSelection: true
            }
        }
    };
}

function getSearchByMemberIdValidationConfiguration() {
    return {
        onfocusout: function (element) {
            this.element(element);
        },
        highlight: function (element) {
            $(element).parent().addClass(IS_ERROR);
        },
        unhighlight: function (element) {
            $(element).parent().removeClass(IS_ERROR);
        },
        ignore: null,
        errorElement: 'span',
        rules: {
            memberIdFriend: {
                required: true
            }
        }
    };
}

function configureSelectFieldFormValidator() {
    $.validator.addMethod('hasValidSelection', function (value, element) {
        const requiredFlag = isRequiredField(this, element);
        return this.optional(element) || !requiredFlag || (element.selectedIndex > 0 && value !== 'default');
    }, function (params, element) {
        return $(element).attr('data-msg-required');
    });
}

function getReferralType() {
    let selectedSearchType = 'assign';
    let $selectedOption = $('input[name="friend-option"]:checked');
    if($selectedOption.length > 0) {
        selectedSearchType = $selectedOption.prop('id');
    }
    return selectedSearchType;
}

function getSearchType() {
    let searchType = 'nameSearch';
    let $selectedOption = $('#searchBy option:selected');
    if($selectedOption.length > 0) {
        searchType = $selectedOption.val();
    }
    return searchType;
}

function isValidSearchForm() {
    let referralType = getReferralType();
    let $form = $('form#checkout');
    if(!$form.length) return false;
    if(referralType === REFERRAL_TYPE_REFERRED) {
        let searchType = getSearchType();
        if(searchType === SEARCH_TYPE_BY_NAME) {
            return validateForm($form, getSearchByNameValidationConfiguration());
        } else if(searchType === SEARCH_TYPE_BY_PHONE) {
            return validateForm($form, getSearchByPhoneValidationConfiguration());
        } else if(searchType === SEARCH_TYPE_BY_MEMBERID) {
            return validateForm($form, getSearchByMemberIdValidationConfiguration());
        } else {
            return false;
        }
    }
    return true;
}

function nextStepCheckout() {
    let $this = $(this);
    setEnrollmentSponsorInformation($this);
}

async function setEnrollmentSponsorInformation($element) {
    try {
        showSpinner('setting enrollment sponsor information started');
        var $referredPerson = $('input[name="referredPerson"]:checked');
        let request = {
            SponsorMemberId: $referredPerson.val(),
            ReferralType: getReferralType()
        };
        let result = await enrollmentService.setEnrollmentSponsor(request);
        if(result && result.IsSuccessful) {
            let referralType = getReferralType();
            if(referralType === REFERRAL_TYPE_REFERRED) {
                $('#loading-announcer').text('referral found and set for enrollment');
                completeFindAFriend('referral');
            } else {
                $('#loading-announcer').text('no referral found for enrollment, setting default referral');
                completeFindAFriend('no_referral');
            }
            moveToNextCheckoutStep(result);
        }
        hideSpinner('setting enrollment sponsor information completed');
    } catch (e) {
        console.error(e);
        hideSpinner('setting enrollment sponsor information completed with error');
    }
}

async function loadStateProvinceList() {
    try {
        let $this = $(this);
        let selectedCountry = $this.val();
        let $option = $this.find('option:selected');
        let itemId = $option.data('itemid');
        showSpinner('loading state/province list started');
        let result = await checkoutService.getStateProvinceList(selectedCountry, itemId);
        hideSpinner('loading state/province list completed');
        if(result && result.StateProvinceList && result.StateProvinceList.length > 0) {
            updateStateProvinceList(result);
        } else {
            $('#stateFriend option:gt(0)').remove();
            console.dir(result);
        }
    } catch (e) {
        console.error(e);
        hideSpinner('loading state/province list completed with error');
    }
}

function updateStateProvinceList(data) {
    if(data) {
        if(data.StateProvinceList) {
            $('#stateFriend option:gt(0)').remove();
            let $state = $('#stateFriend');
            let oneOption = data.StateProvinceList.length === 1;
            $.each(data.StateProvinceList, function (key, value) {
                let $option = $('<option></option>');
                $option.prop('value', value.StateCode).text(value.StateName);
                if(!oneOption) {
                    $state.append($option);
                    $state.parent().removeClass('d-none');
                } else {
                    $option.prop('selected', true);
                    $state.append($option);
                }
            });
            if(oneOption) {
                $state.prop('disabled', true);
            } else {
                $state.prop('disabled', false);
            }
        }
    }
}

function initializeFields() {
    $('#searchBy').val('nameSearch');
    $('#firstNameFriend').val('');
    $('#lastNameFriend').val('');
    $('#countryFriend').val($('#countryFriend option:first').val());
    $('#stateFriend').val($('#stateFriend option:first').val());
    $('#phoneCountryFriend').val($('#phoneCountryFriend').data('defaultcountry'));
    $('#phoneFriend').val('');
    $('#memberIdFriend').val('');
    $('#referredPerson1').prop('checked', true);
}

function addGtmTagForStartFindAFriend() {
    if(
        window.ga_props.length > 0 &&
        window.ga_props[0]
    ) {
        const catalog = window.ga_props[0].CatalogName || '';
        const memberId = window.ga_props[0].MemberId || '';
        const memberType = window.ga_props[0].MemberType || '';
        const cultureCode = window.ga_props[0].CultureCode || '';
        const preferredCultureCode = window.ga_props[0].PreferredCultureCode || '';

        setGenericData(catalog, memberType, memberId, cultureCode, preferredCultureCode);
        if($('#find-afriend-page-load').length || $('#integrated-referral-form').length) {
            startFindAFriend();
        }
    } else {
        console.warn('ga_props is not available or malformed');
    }
}

function initEventHandlers() {
    // handle friend type change
    $('input[name="friend-option"]').on('change', handleFriendTypeChange);

    // enable next button if a referred person is selected
    $(document).on('change', 'input[name="referredPerson"]', changeNextButtonState);

    // switching search renderings
    $('#searchBy').on('change', toggleSearch);

    // searching a friend
    $('.form__search-friend').on('click', findAFriend);
    $('#countryFriend').on('change', loadStateProvinceList);

    $('.findFriendNext').on('click', nextStepCheckout);
    addGtmTagForStartFindAFriend();
}

$(function () {
    initEventHandlers();
    configureSelectFieldFormValidator();
    initializeFields();
    // validateReview();
});
